import { useLocaleState } from "ra-core";
import { useMemo } from "react";

import { useConfigurationContext } from "@/components/atomic-crm/root/ConfigurationContext";
import { formatCompactMoney, formatMoney } from "@/lib/money";

/**
 * The `@/lib/money` helpers bound to the current app locale and the configured
 * currency, e.g. `const { formatMoney } = useMoneyFormat(); formatMoney(deal.amount)`.
 */
export const useMoneyFormat = () => {
  const [locale = "es"] = useLocaleState();
  const { currency } = useConfigurationContext();
  return useMemo(
    () => ({
      formatMoney: (value: number | null | undefined) =>
        formatMoney(value, locale, currency),
      formatCompactMoney: (value: number | null | undefined) =>
        formatCompactMoney(value, locale, currency),
    }),
    [locale, currency],
  );
};

export type MoneyFormat = ReturnType<typeof useMoneyFormat>;
